import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import mixinDisableToolbar from 'src/mixins/mixin-disable-toolbar';
import { EventBus } from 'boot/eventbus';
import { mapGetters } from 'vuex'; // import { mapGetters } from 'vuex'

export default {
  mixins: [mixinDisableToolbar],
  props: {
    'id': String
  },
  components: {
    'registerEditAccount': require('components/RegisterEditAccount').default,
    'userLogin': require('components/UserLogin').default
  },
  data: function data() {
    return {
      step: 1,
      tags: undefined,
      langs: [{
        label: 'NL',
        value: 'nl-nl'
      }, {
        label: 'EN',
        value: 'en-us'
      }, {
        label: 'DE',
        value: 'de-de'
      }],
      lang: this.$i18n.locale,
      enableUserWatch: true
    };
  },
  computed: _objectSpread({}, mapGetters(['user'])),
  watch: {
    lang: function lang(_lang) {
      this.$i18n.locale = _lang.value;

      try {
        this.$q.localStorage.set('locale', this.$i18n.locale);
      } catch (e) {
        console.log(e); // data wasn't successfully saved due to
        // a Web Storage API error
      } // set quasar's language too!!
      // import(`quasar/lang/${lang.value}`).then(language => {
      //     this.$q.lang.set(language.default)
      // })

    },
    user: {
      immediate: true,
      once: true,
      handler: function handler(val) {
        var _this = this;

        if (this.user && this.enableUserWatch) {
          if (this.user.profile.finishedRegister) {
            setTimeout(function () {
              console.log('Funding: ' + _this.user.profile.funding);

              if (_this.user.profile.owner) {
                _this.$router.push({
                  name: 'myCommunities'
                });
              } else if (!_this.user.profile.funding && _this.user.profile.tags && _this.user.profile.tags.includes('texelpolis')) {
                _this.$router.push({
                  name: 'funding'
                });
              } else if (_this.user.profile.subs.length > 0) {
                _this.$router.push({
                  name: 'myCommunities'
                });
              } else if (_this.measuresMine.length > 0) {
                _this.$router.push({
                  name: 'myAreas'
                });
              }
            }, '1000');
          }
        }
      }
    }
  },
  created: function created() {
    EventBus.$emit('closeDrawer');
    var locale = this.$q.localStorage.getItem('locale');

    if (!locale) {
      locale = this.$route.query.lang;
    }

    var aLang = this.langs.find(function (item) {
      return item.value === locale;
    });
    console.log('aLang', aLang);

    if (!aLang) {
      aLang = this.langs[0];
    }

    this.lang = aLang;
    /* EventBus.$emit('closeDrawer')
     let locale = this.$q.localStorage.getItem('locale')
    console.log('WW' + locale)
    if (locale) {
        console.log('0A')
        this.$i18n.locale = this.langs.find(item => item.value === locale)
    } else if (this.$route.query.lang === 'de-de') {
        console.log('A')
        this.$i18n.locale = {
            label: 'DE',
            value: 'de-de'
        }
    } else if (this.$route.query.lang === 'en-us') {
        console.log('B')
        this.$i18n.locale = {
            label: 'EN',
            value: 'en-us'
        }
    } else {
        console.log('C')
        this.$i18n.locale = {
            label: 'NL',
            value: 'nl-nl'
        }
    }
     let aLang = this.langs.find(item => item.value === locale)
    console.log('aLang', aLang)
    if (!aLang) { aLang = this.langs[0] }
     this.lang = aLang */
  },
  beforeDestroy: function beforeDestroy() {
    EventBus.$off('drawerChanged'); // EventBus.$off('drawerChanged', this.drawerChangedHandler)
  },
  mounted: function mounted() {
    var _this2 = this;

    // console.log('tags', this.$route.query)
    // console.log('lang', this.$route.query.lang)
    // console.log('tags', this.tags)
    if (this.$route.query.tags) {
      this.tags = JSON.parse(this.$route.query.tags); // console.log('tags2', this.tags)
    } // console.log(this.$route.query.id)


    EventBus.$emit('closeDrawer');

    if (this.id) {
      this.step = 2;
    }

    setTimeout(function () {
      // console.log('DISABLE WATCH')
      _this2.enableUserWatch = false;
    }, '3000');
  }
};